<template>
    <div class="page-overlay" @click="hideOverlay()"></div>
</template>
<script>
var $ = require('jquery')
window.jQuery = $
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['overlayFreeze'])
  },
  methods: {
    hideOverlay () {
      this.$store.commit('SET_OVERLAY_FREEZE', true)
      $('.page-overlay').removeClass('show')
    }
  }
}
</script>
<style scoped>
    .page-overlay {
        position: fixed;
        display: none;
        width: 100%;
        height: 100%;
        top: 0; 
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0,0,0,0.5);
        z-index: 2;
        cursor: pointer;
    }
    .page-overlay.show {
        display: block;
    } 
</style>



// WEBPACK FOOTER //
// overlay.vue?7cf62f44